/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import BaseValidator from 'ember-cp-validations/validators/base';

const SurveyQuestionOptionsNotDuplicated = BaseValidator.extend({
  validate(value, options, model) {
    if ((model.isDropdown || model.isMultiSelect) && model.data.hasDuplicatedOptions) {
      return `Step ${model.step.get('order') + 1} Question ${
        model.questionOrder
      }: Options can not be duplicated.`;
    }

    return true;
  },
});

SurveyQuestionOptionsNotDuplicated.reopenClass({
  getDependentsFor() {
    return ['model.isDropdown', 'model.isMultiSelect', 'model.data.hasDuplicatedOptions'];
  },
});

export default SurveyQuestionOptionsNotDuplicated;
